import React, { useState, useEffect } from 'react';
import { getElapsedTimeText, FONT_SIZE } from '../../Variables';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Span = styled.span`
  font-size: ${FONT_SIZE.small};
`

const ElapsedTime = ({ created }) => {
    const { t } = useTranslation();
    const [elapsedTime, setElapsedTime] = useState(getElapsedTimeText(created, t));

    useEffect(() => {
        const interveal = setInterval(() => {
            setElapsedTime(getElapsedTimeText(created, t));
        }, 1000);
        return () => clearInterval(interveal);
    }, [created]);

  return (
    <Span>{elapsedTime}</Span>
  )
}

export default ElapsedTime